import React from "react";
import { t } from "@lingui/core/macro";
import { useParams } from "react-router-dom";

import ContactInfoView from "../contact-view";
import { CompanyContactService } from "../../../services/company-contact-service";

export function Component() {
  const { contactId, companyId } = useParams();
  const service = new CompanyContactService(+companyId);

  return (
    <ContactInfoView
      id={contactId}
      service={service}
      redirectUrl={`/${companyId}/users/active?tab=contacts`}
    />
  );
}

export const companyContactViews = () => {
  return {
    label: t`Contacts`,
    navList: [
      { id: "info", label: t`Info` },
      { id: "groups", label: t`Groups` },
    ],
  };
};

Component.displayName = "CompanyContactInfoView";
